<template>
  <div>
    <!-- 工作台 -->
    <div>
      <div class="tab_add">
        <span>位置：</span>
        <span>工作台</span>
        <!-- <button @click="exportDeta">导出</button> -->
      </div>
      <div class="navFrame">
        <div class="navDataBig">
          <div v-for="v in navList" :key="v.id" @click="noteTem(v.id)">
            <div>{{v.title}}</div>
            <div>
              <div>
                <span>{{v.navTotal}}</span>
                <span>{{v.company}}</span>
              </div>
              <div>
                <img :src="v.srcUrl" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="navDataSmall">
          <div v-for="v in navSmall" :key="v.id">
            <div>{{v.title}}</div>
            <div>
              <img :src="v.srcUrl" alt />
            </div>
          </div>
        </div>
      </div>
      <!-- 卡片开始 -->
      <el-card class="conentBox">
        <el-table
        :data="scenicData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width: 100%"
      >
        <el-table-column prop="ScenicID" label="景区ID"></el-table-column>
        <el-table-column prop="Name" label="景区名称" width="200"></el-table-column>
        <el-table-column prop="charge" label="短信类型">
            <template slot-scope="scope">
              {{scope.row.charge=='1'?'计费':'计时'}}
            </template>
        </el-table-column>
        <el-table-column prop="Balance" label="短信余额/剩余时间">
          <template slot-scope="scope">
              <span v-if="scope.row.charge=='1'">{{scope.row.Balance}}</span>
              <span v-if="scope.row.charge=='2'">{{scope.row.charge_time}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Phone" label="手机号"></el-table-column>
        <el-table-column prop="LinkMan" label="用户名"></el-table-column>
        <el-table-column  label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="changePassw(scope.row)">景区下线</el-button>
          </template>
        </el-table-column>
      </el-table>
        <!-- 分页结束 -->
      </el-card>
      <!-- 卡片结束 -->
      <!-- 短信模板弹框开始 -->
      <el-dialog :close-on-click-modal="false"
        title="短信模板"
        :visible.sync="noteDialogVisible"
        :before-close="noteHandleClose"
        width="53%"
        center
      >
        <el-divider></el-divider>
        <el-table
          :data="noteData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column prop="Name" label="景区名称"></el-table-column>
          <el-table-column prop="LinkMan" label="联系人"></el-table-column>
          <el-table-column prop="Phone" label="电话"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="examineFn(scope.row)">审核</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <!-- <el-pagination
            @current-change="noteHandleCurrentChange"
            :current-page="notePar.page"
            :page-size="8"
            background
            layout="total, prev, pager, next, jumper"
            :total="total"
          ></el-pagination> -->
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{notePar.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total" @current-change="noteHandleCurrentChange"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </el-dialog>
      <!-- 短信模板弹框结束 -->

      <!-- 短信充值审核弹框开始 -->
      <el-dialog :close-on-click-modal="false"
        title="短信充值审核"
        :visible.sync="noteRechargeDialogVisible"
        :before-close="rechargeHandleClose"
        width="53%"
        center
      >
        <el-divider></el-divider>
        <div class="noteDialog">
          <div class="noteDialogTop">
            <div>
              <span>短信模板内容</span>
              <span>(正在使用)</span>
            </div>
            <div>
              <div class="fsw">{{examineData.Sms}}</div>
            </div>
          </div>
          <div class="noteDialogbotton">
            <div>
              <span>短信模板内容</span>
              <span style="color:#FFCC00">(待审核)</span>
            </div>
            <div>
              <div class="fsw">{{examineData.ExamineSms}}</div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="btnL" @click="failFn(3)">不通过</el-button>
          <el-button class="btnR" type="primary" @click="failFn(1)">通过</el-button>
        </span>
      </el-dialog>
      <!-- 短信充值审核弹框结束 -->
    </div>
  </div>
</template>

<script>
import {
  workePost,
  notePost,
  noteExaminePost,
  noteExamineFailPost,
  getJfylistProduct
} from "@/request/worke.js";
import {
  scenicPost
} from "@/request/scenics.js";
import cityOptions from "@/assets/city.json";

import { SmsList , statusPost } from "@/request/scenics.js";
import { MessageBox } from "element-ui"

export default {
  data() {
    return {
      scenicData:[],
      titleData: {},
      imgXl: require("@/images/scenic/sj.png"), // 下拉图标
      noteDialogVisible: false, // 短信模板
      noteRechargeDialogVisible: false, // 短信充值审核,
      // 短信模板传参
      notePar: {
        page: 1,
        page_size: 8,
        token: ""
      },
      noteData: [], // 短信模板数据
      total: 1, // 短信模板总条数
      examineData: "", // 短信模板审核展示
      scenic_id: "", // 景区id
      tableData: [
      ],
      options: [
        {
          value:'0',
          label:'上线'
        },
        {
          value:'1',
          label:'下线'
        }
      ],
      value: "",
      navList: [
        {
          id: 1,
          title: "短信剩余数量",
          navTotal: "",
          srcUrl: require("@/images/worke/dxgl.png"),
          company: "条"
        },
        {
          id: 2,
          title: "短信模板审核",
          navTotal: "",
          srcUrl: require("@/images/worke/sh.png"),
          company: "条"
        },
        // {
        //   id: 3,
        //   title: "分销商审核",
        //   navTotal: "",
        //   srcUrl: require("@/images/worke/fx.png"),
        //   company: "个"
        // },
        {
          id: 4,
          title: "短信充值审核",
          navTotal: "",
          srcUrl: require("@/images/worke/app.png"),
          company: "条"
        }
      ],
      navSmall: [
        {
          id: 1,
          title: "app管理端",
          srcUrl: require("@/images/worke/cz.png")
        },
        // {
        //   id: 2,
        //   title: "银联小程序",
        //   srcUrl: require("@/images/worke/yl.png")
        // }
      ],
      titleData: [],
      Token: "",
      data:{
        token:window.sessionStorage.getItem("Token")
      },
      cityOption:[],
      scenicOption:[]
    };
  },
  mounted() {
    this.cityOption = cityOptions;
    let data = {
      token:window.sessionStorage.getItem("Token"),
      page:1,
      page_size:9999
    }
    scenicPost(data).then(res=>{
      if(res.data.status=='ok'){
        this.scenicOption = res.data.result.data
      }
    })
    this.Token = window.sessionStorage.getItem("Token");
    this.notePar = {
      page: 1,
      page_size: 8,
      token: this.Token
    };
    this.grtList(this.notePar);
    this.getList()
  },
  methods: {
    exportDeta(){
      window.location.href = 'http://xwt.softykt.net/api/scenic/exportToCsv?start_date=' +'2025-01-01 00:00:00' + '&end_date'+ '2025-06-20 23:59:59' 
    },
    changePassw(row){
      MessageBox('此操作将下线该景区, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            token:window.sessionStorage.getItem("Token"),
            scenic_id:row.ScenicID,
            status:'2'
          }
          statusPost(data).then(res=>{
            if(res.data.rcode==200){
              this.$message.success('景区下线成功')
              this.getList()
            }else{
              this.$message.error(res.data.msg)

            }
          })
        }).catch(() => {        
       });
    },
    getList(){
      SmsList(this.data).then(res=>{
        if(res.data.rcode==200){
          this.scenicData = res.data.result
        }
      })
    },
   

    // 获取接口
    grtList() {
      let upData = {
        token: this.Token
      };
      workePost(upData).then(res => {
        if (res.data.rcode == 200) {
          this.navList.map((item, index) => {
            item.navTotal = res.data.result[index].count;
          });
        }
      });
    },
    // 获取短信模板数据
    getNoteList(data) {
      notePost(data).then(res => {
        console.log(res);
        this.total = res.data.result.total;
        this.noteData = res.data.result.data;
      });
    },
    // 短信模板审核
    examineFn(row) {
      let upData = {
        scenic_id: row.ScenicID,
        token: this.Token
      };
      this.scenic_id = row.ScenicID;
      noteExaminePost(upData).then(res => {
        console.log(res);
        this.examineData = res.data.result;
      });
      this.noteRechargeDialogVisible = true;
    },
    // 短信模板审核通过
    failFn(e) {
      let updata = {
        scenic_id: this.scenic_id,
        status: e,
        token: this.Token
      };
      noteExamineFailPost(updata).then(res => {
        console.log(res);
        if (res.data.rcode == 200) {
          this.getNoteList(this.notePar);
          this.noteRechargeDialogVisible = false;
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 短信模板
    noteTem(num) {
      if (num == 1) {
        // 短信剩余数量
      }
      if (num == 2) {
        // 短信模板审核
        this.getNoteList(this.notePar);
        this.noteDialogVisible = true;
      }
      if (num == 3) {
        // 分销商审核
      }
      if (num == 4) {
        // 短信充值审核
        this.noteRechargeDialogVisible = true
      }

      console.log(num);
    },
    // 短信审核关闭X
    noteHandleClose(done) {
      done();
    },
    // 短信充值审核关闭X
    rechargeHandleClose(done) {
      this.examineData = ''
      done();
    },
    // 短信模板分页
    noteHandleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.notePar.page = val;
      this.getNoteList(this.notePar);
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-button.el-button--default {
  background: white;
  border: 1px solid #ff4d4f;
  color: #ff4d4f;
}
.btnL {
  width: 100px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #ff4d4f;
  border-radius: 4px;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  /* identical to box height */
  text-align: center;
  color: #ff4d4f;
  box-sizing: border-box;
  margin-right: 20px;
}
.btnR {
  width: 100px;
  height: 40px;
  background: #006afa;
  border-radius: 4px;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  /* identical to box height */
  color: #ffffff;
}
.noteDialogTop,
.noteDialogbotton {
  width: 100%;
  height: 150px;
  margin-bottom: 36px;
  > div:nth-child(1) {
    width: 150px;
    height: 22px;
    line-height: 22px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    margin-bottom: 6px;
    // background: red;
    > span:nth-child(2) {
      color: #4ecb73;
    }
  }
  > div:nth-child(2) {
    width: 100%;
    height: 120px;
    border: 1px solid #246deb;
    border-radius: 4px;
    > div:nth-child(1) {
      width: 397px;
      height: 22px;
      padding: 20px;
    }
  }
}
.navFrame {
  width: 100%;
  display: flex;
  margin: 17px 0;
  flex-wrap: wrap;
  justify-content: space-between;
  .navDataBig {
    display: flex;
    flex-wrap: wrap;
    margin-right: 2rem;
    > div {
      width: 30.8rem;
      height: 150px;
      background: #ffffff;
      border-radius: 4px;
      margin-right: 2rem;
      margin-bottom: 1rem;
      &:last-child{
        margin-right: 0;
      }
      > div:nth-child(1) {
        width: 84px;
        height: 20px;
        margin-left: 20px;
        margin-top: 17px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */

        color: #666666;
      }
      > div:nth-child(2) {
        height: 56px;
        display: flex;
        margin-top: 40px;
        // background: red;
        > div:nth-child(2) {
          width: 20%;
          img {
            width: 70px;
            height: 60px;
            margin-right: 20px;
          }
        }
        > div:nth-child(1) {
          width: 65%;
          height: 100px;
          margin-bottom: 20px;
          display: flex;
          > span:nth-child(1) {
            display: block;
            height: 100%;
            line-height: 100px;
            margin-left: 21px;
            margin-right: 8px;
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 600;
            font-size: 30px;
            line-height: 56px;
            color: #246deb;
            text-align: left;
          }
          > span:nth-child(2) {
            display: block;
            width: 20px;
            height: 100%;
            margin-top: 20px;
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
            /* identical to box height */
            color: #797979;
          }
        }
      }
    }
  }
  .navDataSmall {
    flex: 1;
    display: flex;
    // flex-wrap: wrap;
    // background: yellow;
    > div {
      width:14.4rem;
      height: 150px;
      margin-bottom: 1rem;
      background: #ffffff;
      border-radius: 4px;
      &:nth-child(1){
        margin-right: 1rem;
      }
      > div:nth-child(1) {
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #666666;
        margin-top: 17px;
        margin-left: 20px;
      }
      > div:nth-child(2) {
        width: 95%;
        height: 60px;
        // margin-right: 20px;
        margin-top: 40px;
        display: flex;
        justify-content: flex-end;
        img {
          width: 56px;
          height: 56px;
        }
      }
    }
  }
}


.unaudite {
  color: #ff4d4f;
}

/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 45px auto 40px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
/deep/.el-pagination{
  display: flex;
  flex-wrap: wrap;
}

.tab_add{
  span{
    font-size: 1.4rem;
    color: #666;
    &:nth-child(2){
      color: #000000;
    }
  }
}
/deep/.el-dialog__title{
  color: #000 !important;
  font-family: OPPOSans !important;
  font-size: 20px !important;
  font-weight: 400 !important;
}
/deep/.el-dialog__headerbtn {
  top: 0 !important;
}
/deep/.el-dialog__headerbtn .el-dialog__close{
  font-size: 2.8rem;
}
</style>